// Ref: https://github.com/orangeable/jquery-table-sort
// jQuery:
$(document).ready(function () {

    // Table sorting
    $(document).on('click', 'table thead tr th:not(.no-sort)', function () {
        let table = $(this).parents('table');
        let rows = $(this).parents('table').find('tbody tr').toArray().sort(TableComparer($(this).index()));
        let dir = ($(this).hasClass('sort-asc')) ? 'desc' : 'asc';

        if (dir == 'desc') {
            rows = rows.reverse();
        }

        for (let i = 0; i < rows.length; i++) {
            table.append(rows[i]);
        }

        table.find('thead tr th').removeClass('sort-asc').removeClass('sort-desc');
        $(this).removeClass('sort-asc').removeClass('sort-desc').addClass('sort-' + dir);
    });

    // Remove duplicates from dropdowns
    $('.product-table-filter').each(function () {
        const $select = $(this);
        const seen = {};
        $select.find('option').each(function () {
            const $option = $(this);
            if (seen[$option.text()]) {
                $option.remove();
            } else {
                seen[$option.text()] = true;
            }
        });
    });

    // Table filtering
    $('.product-table-filter').on('change', function () {
        // Get the selected values of all dropdowns
        let filters = {};
        $('.product-table-filter').each(function () {
            const filterIndex = $(this).data('filter-index');
            const selectedOption = $(this).val();
            if (selectedOption !== '') {
                filters[filterIndex] = selectedOption;
            }
        });

        $('tbody tr').each(function () {
            const $row = $(this);
            let match = true;

            // Check if the row matches all selected values
            for (let filterIndex in filters) {
                const rowValue = $row.find('td:nth-child(' + filterIndex + ')').text();
                if (rowValue !== filters[filterIndex]) {
                    match = false;
                    break;
                }
            }

            // Show or hide the row based on whether it matches all selected values
            if (match) {
                $row.show();
            } else {
                $row.hide();
            }
        });
    });

    // Initialise Glide slider
    if ($('.glide').length) {
        new Glide('.glide', {
            type: 'carousel',
            // startAt: 0,
            perView: 2,
            peek: 180,
            focusAt: 'center',
            gap: 30,
            autoplay: 10000,
            hoverpause: true,
            animationDuration: 800,
            animationTimingFunc: 'ease',
            breakpoints: {
                1400: {
                    perView: 1,
                    peek: 0
                },
            }
        }).mount();
    }

    // Get YouTube thumbnails
    $('[data-video-url]').each(function () {
        const videoUrl = $(this).data('video-url');
        const thumbnailUrl = getYouTubeThumbnail(videoUrl);
        $(this).data('thumbnail-url', thumbnailUrl);

        // Set the thumbnail as the background image of the div
        $(this).css('background-image', 'url(' + thumbnailUrl + ')');
    });

    $('.media_slide.image_slide').on('click', function () {
        const imageUrl = $(this).data('image-url');
        $('#media-popup-image').attr('src', imageUrl);
        $('#video-iframe').hide();
        $('#video-popup').show();
        $('#media-popup-image').show();
    });

    $('.media_slide.video_slide').on('click', function () {
        // Get the video URL
        const videoUrl = $(this).data('video-url');

        // Convert the video URL to an embed URL
        let videoId = videoUrl.split('v=')[1];
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition != -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }
        const embedUrl = 'https://www.youtube.com/embed/' + videoId;

        // Set the source of the iframe to the embed URL
        $('#video-iframe').attr('src', embedUrl);

        // hide image
        $('#media-popup-image').hide();
        // Show the popup
        $('#video-popup').show();
        $('#video-iframe').show();
    });

    // Close the popup when it's clicked
    $('#video-popup').on('click', function () {
        // Hide the popup
        $(this).hide();
        $('#video-popup').hide();
        $('#media-popup-image').hide();

        // Stop the video
        $('#video-iframe').attr('src', '');
    });
});

// table data comparison:
function TableComparer(index) {
    return function (a, b) {

        let val_a = getNumericPart(TableCellValue(a, index));
        let val_b = getNumericPart(TableCellValue(b, index));
        let result = val_a.toString().localeCompare(val_b);

        if ($.isNumeric(val_a) && $.isNumeric(val_b)) {
            result = val_a - val_b;
        }

        if (isDate(val_a) && isDate(val_b)) {
            let date_a = new Date(val_a);
            let date_b = new Date(val_b);
            result = date_a - date_b;
        }

        return result;
    };
}

// get table cell value:
function TableCellValue(row, index) {
    return $(row).children('td').eq(index).text();
}

// date validation:
function isDate(val) {
    let d = new Date(val);

    return !isNaN(d.valueOf());
}

// Extracts the numeric part from a string
function getNumericPart(str) {
    let match = str.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : str;
}

function getYouTubeThumbnail(videoUrl) {
    // Extract the video id from the url
    let videoId = videoUrl.split('v=')[1];
    const ampersandPosition = videoId.indexOf('&');

    if (ampersandPosition != -1) {
        videoId = videoId.substring(0, ampersandPosition);
    }

    // Return the thumbnail url
    return 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';
}